(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SswJga = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  var STAFFEL_RE = /^(\d+)\s*-\s*(\d+)\s*Personen$/i;
  var TAG_KURZ = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var TAG_LANG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function opt(v, i) {
    var k = 'option' + (i + 1);
    if (v && v[k] != null) return String(v[k]);
    if (v && v.options && v.options[i] != null) return String(v.options[i]);
    return '';
  }
  function kaufbar(v) { return !!v && v.available === true && !/anfrag/i.test(String(v.title || '') + ' ' + opt(v, 1)); }

  function staffeln(varianten) {
    var out = [], gesehen = {};
    (varianten || []).forEach(function (v) {
      if (!kaufbar(v)) return;
      var text = opt(v, 1).trim();
      var m = text.match(STAFFEL_RE);
      if (!m || gesehen[text]) return;
      var von = Number(m[1]), bis = Number(m[2]);
      if (!(von >= 1 && bis >= von)) return;
      gesehen[text] = true;
      out.push({ von: von, bis: bis, text: text });
    });
    return out.sort(function (a, b) { return a.von - b.von; });
  }
  function staffelVon(varianten, personen) {
    var n = Number(personen);
    var s = staffeln(varianten).filter(function (x) { return n >= x.von && n <= x.bis; });
    return s.length ? s[0] : null;
  }
  function maxPersonen(varianten) {
    return staffeln(varianten).reduce(function (m, s) { return Math.max(m, s.bis); }, 0);
  }

  function dauerMin(text) {
    var m = String(text == null ? '' : text).trim().match(/^(\d+)\s*Stunden?$/i);
    if (!m) return null;
    var h = Number(m[1]);
    return h > 0 ? h * 60 : null;
  }

  function dauerOptionen(varianten, personen) {
    var st = staffelVon(varianten, personen);
    if (!st) return [];
    var out = [], gesehen = {};
    (varianten || []).forEach(function (v) {
      if (!kaufbar(v) || opt(v, 1).trim() !== st.text) return;
      var min = dauerMin(opt(v, 0));
      var preis = Math.round(Number(v.price));
      if (!min || gesehen[min] || !(preis > 0)) return;
      gesehen[min] = true;
      out.push({ min: min, text: opt(v, 0).trim(), preisCent: preis, variantId: v.id, variantTitle: String(v.title || '') });
    });
    return out.sort(function (a, b) { return a.min - b.min; });
  }
  function alleDauern(varianten) {
    var out = [];
    (varianten || []).forEach(function (v) {
      if (!kaufbar(v) || !STAFFEL_RE.test(opt(v, 1).trim())) return;
      var min = dauerMin(opt(v, 0));
      if (min && out.indexOf(min) < 0) out.push(min);
    });
    return out.sort(function (a, b) { return a - b; });
  }

  function rechne(varianten, wahl) {
    var max = maxPersonen(varianten);
    if (!max || !wahl) return null;
    var p = Math.round(Number(wahl.personen) || 0);
    p = Math.max(1, Math.min(max, p));
    var o = dauerOptionen(varianten, p).filter(function (x) { return x.min === Number(wahl.dauerMin); })[0];
    if (!o) return null;
    return { personen: p, dauerMin: o.min, variantId: o.variantId, variantTitle: o.variantTitle, preisCent: o.preisCent };
  }

  function produktText(ptitle, variantTitle) { return String(ptitle || '').trim() + ', ' + String(variantTitle || '').trim(); }

  function euro(cent) {
    var n = Math.round(Number(cent) || 0);
    var ganz = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var rest = ('0' + (n % 100)).slice(-2);
    return ganz + (rest === '00' ? '' : ',' + rest) + ' €';
  }
  function dauerText(min) {
    var h = Math.floor(min / 60), m = min % 60;
    if (!m) return h + ' Std.';
    return h + ',' + (m === 30 ? '5' : String(Math.round(m / 6))) + ' Std.';
  }
  function endeVon(start, dauerMin) {
    var t = start.split(':');
    var m = Number(t[0]) * 60 + Number(t[1]) + dauerMin;
    return ('0' + Math.floor(m / 60)).slice(-2) + ':' + ('0' + (m % 60)).slice(-2);
  }
  function dauerLang(min) {
    var n = Number(min);
    if (n === 60) return '1 Stunde';
    if (n % 60 === 0) return (n / 60) + ' Stunden';
    return dauerText(n).replace(' Std.', ' Stunden');
  }

  function wochentag(date) {
    var p = String(date).split('-');
    return new Date(Date.UTC(Number(p[0]), Number(p[1]) - 1, Number(p[2]))).getUTCDay();
  }
  function uhr(t) { return String(t || '').replace(/^0(\d)/, '$1'); }
  function zeitraum(start, dauerMin) { return uhr(start) + ' bis ' + uhr(endeVon(start, dauerMin)); }
  function datumText(date) {
    var d = String(date);
    return TAG_KURZ[wochentag(d)] + '., ' + d.slice(8, 10) + '.' + d.slice(5, 7) + '.' + d.slice(0, 4);
  }
  function datumKurz(date) {
    var d = String(date);
    return TAG_KURZ[wochentag(d)] + '. ' + d.slice(8, 10) + '.' + d.slice(5, 7) + '.';
  }
  function terminText(date, time, dauerMin) { return datumText(date) + ', ' + zeitraum(time, dauerMin) + ' Uhr'; }

  function sortiert(wochentage) {
    var ws = [];
    (wochentage || []).forEach(function (w) { w = Number(w); if (w >= 0 && w <= 6 && ws.indexOf(w) < 0) ws.push(w); });
    return ws.sort(function (a, b) { return ((a + 6) % 7) - ((b + 6) % 7); });
  }
  function tageMit(wochentage, namen) {
    var ws = sortiert(wochentage);
    if (!ws.length || ws.length === 7) return '';
    var idx = ws.map(function (w) { return (w + 6) % 7; });
    var amStueck = idx.every(function (x, i) { return i === 0 || x === idx[i - 1] + 1; });
    if (amStueck && ws.length >= 3) return namen[ws[0]] + ' bis ' + namen[ws[ws.length - 1]];
    var n = ws.map(function (w) { return namen[w]; });
    if (n.length === 1) return n[0];
    return n.slice(0, -1).join(', ') + ' und ' + n[n.length - 1];
  }
  function tageText(wochentage) { return tageMit(wochentage, TAG_LANG); }
  function tageKurz(wochentage) { return tageMit(wochentage, TAG_KURZ); }

  function warenkorbZeile(erg, res, termin, extra) {
    if (!erg || !erg.variantId) throw new Error('Die Auswahl passt nicht. Bitte lade die Seite neu.');
    if (!res || !res.reservationId) throw new Error('Die Reservierung fehlt. Bitte versuch es noch einmal.');
    if (!termin || !termin.date || !termin.time) throw new Error('Bitte wähle zuerst einen Termin.');
    var props = {
      'Termin': terminText(termin.date, termin.time, erg.dauerMin),
      'Personen': String(erg.personen),
      '_SSW-Reservierung': String(res.reservationId),
      '_SSW-Freigabe': String(res.releaseToken || ''),
      '_SSW-Dauer': String(erg.dauerMin),
      '_SSW-Start': termin.date + 'T' + termin.time,
      '_SSW-JGA': '1'
    };
    var name = String((extra && extra.name) || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    var wuensche = String((extra && extra.wuensche) || '').replace(/\s+/g, ' ').trim().slice(0, 300);
    if (name) props['_SSW-JGA-Name'] = name;
    if (wuensche) props['_SSW-Wuensche'] = wuensche;
    return { id: erg.variantId, quantity: 1, properties: props };
  }

  return {
    staffeln: staffeln, staffelVon: staffelVon, maxPersonen: maxPersonen, dauerMin: dauerMin, dauerOptionen: dauerOptionen,
    alleDauern: alleDauern, rechne: rechne, produktText: produktText, terminText: terminText, datumText: datumText,
    datumKurz: datumKurz, uhr: uhr, zeitraum: zeitraum, wochentag: wochentag, tageText: tageText, tageKurz: tageKurz,
    warenkorbZeile: warenkorbZeile, euro: euro, dauerText: dauerText, endeVon: endeVon, dauerLang: dauerLang
  };
});
